import { Theme, Select, SelectProps, FormControl, FormControlProps, FormHelperText, FormHelperTextProps, InputLabelProps, TextFieldProps, FormLabel } from '@mui/material';
import {makeStyles} from '@mui/styles';

type StyleProps = {
  elevation?: number;
}

const useStyles = makeStyles((theme : Theme) => ({
  root: {
    
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  input: {
    boxShadow: ({elevation} : StyleProps) => theme.shadows[elevation]
  },
  helper: {

  },
}), {name: 'ElevatedSelect'});

export type ElevatedSelectProps = FormControlProps
                                & FormHelperTextProps
                                & InputLabelProps
                                & Partial<TextFieldProps>
                                & SelectProps
                                & StyleProps;

const ElevatedSelect = ({
  children,
  color,
  disabled,
  elevation = 1,
  error,
  filled,
  focused,
  fullWidth,
  FormHelperTextProps,
  helperText,
  hiddenLabel,
  InputLabelProps,
  label,
  margin,
  name,
  required,
  variant = 'filled',
  size,
  sx,
  ...selectProps
} : ElevatedSelectProps) => {
  const formControlProps = {
    color,
    disabled,
    error: !!error,
    focused,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    sx
  };
  const inputLabelProps = {
    color,
    disabled,
    error: !!error,
    filled,
    focused,
    required,
    ...InputLabelProps
  };
  const formHelperTextProps = {
    disabled,
    error: !!error,
    filled,
    focused,
    margin,
    required,
    ...FormHelperTextProps
  };

  const classes = useStyles({elevation});

  return (
    <FormControl className={classes.root} {...formControlProps}>

      {label && (
        <FormLabel className={classes.label} id={`${name}-label`} htmlFor={name} {...inputLabelProps}>
          {label}
        </FormLabel>
      )}
      
      <Select
        className={classes.input}
        id={name}
        labelId={`${name}-label`}
        aria-labelledby={`${name}-label`}
        aria-describedby={`${name}-helper-text`}
        color={color}
        disabled={disabled}
        error={!!error}
        fullWidth={fullWidth}
        margin={margin}
        name={name}
        required={required}
        variant={variant}
        {...selectProps}
      >
        {children}
      </Select>
      
      {error && (
        <FormHelperText className={classes.helper} id={`${name}-helper-text`} {...formHelperTextProps}>
          {error || helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default ElevatedSelect;